import { buildI18nInjectionToken } from '@pct-ng/transloco';

const I18nScope = 'ng/feature/rich-text/tip-tap';
export const I18nProviderInjectionToken = buildI18nInjectionToken(I18nScope);
